import React from "react";
import { string } from "prop-types";

const YouTubeEmbed = ({ id, title = "", ...props }) => {
	return (
		<iframe
			className="video-responsive__iframe"
			style={{ width: "100%" }}
			height="315"
			src={`https://www.youtube.com/embed/${id}`}
			title={title}
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
			{...props}
		/>
	);
};

YouTubeEmbed.propTypes = {
	id: string.isRequired,
	title: string,
};

export default YouTubeEmbed;
